import React from "react";
import Card from "../Shared/Card/Card";
import { IPerson } from "../../models/person/Person";
import { DetailRow } from "./DetailRow";


interface ContactInformationProps extends Partial<IPerson> { }

export function ContactInformation({
  active,
  unsubscribed,
  firstName,
  lastname,
  telephone,
  telephone2,
  email,
  addressLine1,
  addressLine2,
  addressLine3,
  addressLine4,
  postcode,
}: ContactInformationProps) {

  //@ts-ignore
  return <Card title="Contact Information">
    <div className="grid grid-cols-2 gap-4">
      <dl className="ml-2 text-sm divide-y my-2 divide-gray-100">
        <DetailRow label="First Name" value={firstName} />
        <DetailRow label="Last Name" value={lastname} />
        <DetailRow label="Telephone" value={telephone} />
        <DetailRow label="Telephone 2" value={telephone2} />
        <DetailRow label="Email" value={email} />
        <DetailRow
          label="Unsubscribed"
          value={unsubscribed ? "Yes" : "No"}
        />
      </dl>
      <dl className="text-sm divide-y divide-gray-100">
        <DetailRow label="Address Line 1" value={addressLine1} />
        <DetailRow label="Address Line 2" value={addressLine2} />
        <DetailRow label="Address Line 3" value={addressLine3} />
        <DetailRow label="Address Line 4" value={addressLine4} />
        <DetailRow label="Postcode" value={postcode} />
      </dl>
    </div>
  </Card>

}